import ResearchDialog from './researchDialog'
export default ResearchDialog
